import "./App.scss";
import {
  useReactCheckerVersion,
  monoTemplateAlert,
  sendMessageSentry
} from "./lib/react-checker-version";
import MainRouter from "./router/main.router";
import { DefaultToastOptions, Toaster } from "react-hot-toast";
import { MxMapProvider } from "@rf/context/MxMapContext";
import { useEffect } from "react";
import {
  isProduction,
  isStage
} from "./src-refactor/modules/shared/helpers/check-environment";
import useLoadTitle from "./src-refactor/modules/shared/hooks/useLoadTitle";

const time = {
  10: 10 * 60 * 1000,
  5: 5 * 60 * 1000,
  2: 2 * 60 * 1000
};
function App() {
  useLoadTitle();
  useReactCheckerVersion({
    nameProject: "MAXCORE",
    reevaluatingTime: isStage() ? time[2] : time[5],
    waitTimeAfterDoLater: isStage() ? time[5] : time[5],
    localProjectVersion: String(import.meta.env.APP_VERSION || ""),
    enabled: isStage() || isProduction(),
    refecthOnFocus: true,
    refetchOnReconnect: true,
    templateAlert: monoTemplateAlert,
    handleCatchErrorToUpdate(extra) {
      sendMessageSentry({
        messageError: "Error al actualizar la version",
        level: "error",
        extra: { ...extra }
      });
    }
  });

  // useWeeklyModal({ modalKey: "weekly-modal" });

  const themeToaster: DefaultToastOptions = {
    style: {
      fontFamily: "SF Pro Display",
      fontSize: "0.875rem"
    },
    error: {
      iconTheme: {
        primary: "#DC202D",
        secondary: "#fff"
      },
      style: {
        fontFamily: "SF Pro Display",
        fontSize: "0.875rem"
      }
    },
    success: {
      iconTheme: {
        primary: "#4CAF50",
        secondary: "#fff"
      },
      style: {
        fontFamily: "SF Pro Display",
        fontSize: "0.875rem"
      }
    }
  };
  return (
    <div className="App">
      <Toaster containerStyle={{ zIndex: 11001 }} toastOptions={themeToaster} />
      <MxMapProvider>
        <MainRouter />
      </MxMapProvider>
    </div>
  );
}

export default App;
